import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "@/styles/common.scss";
import 'animate.css';
import VueWechatTitle from 'vue-wechat-title'
Vue.use(VueWechatTitle)
Vue.config.productionTip = false;
//引入抽奖插件
import VueLuckyCanvas from '@lucky-canvas/vue'
Vue.use(VueLuckyCanvas)
new Vue({
  router,
  data: () => {
    return {
      
    };
  },
  render: h => h(App)
}).$mount("#app");
